import { Button, MenuItem, Link } from '@mui/material';
import { Person } from '@mui/icons-material';
import React, { useState } from 'react';
import __t from '../../lib/traduzioni';
import { useLocalStorage } from 'react-use';

import useBSSLogger from '../../hooks/useBSSLogger';
import Whitespace from '../Whitespace';
const {logger} = useBSSLogger();


import BSSMenu from '../form/BSSMenu';
import { ArrowRight } from '@mui/icons-material';


const MenuUtente = () => {

    const [preventivoStorage, aggiornaPreventivoStorage, rimuoviPreventivoStorage] = useLocalStorage("spedizioniweb2_preventivo_form");
    const [carrelloStorage = {preventivi: [], pagamenti: {}, datiFatturazione: {}}, aggiornaCarrelloStorage, rimuoviCarrelloStorage] = useLocalStorage("spedizioniweb2_preventivo_carrello");
    const {preventivi} = carrelloStorage;


    const [statoMenu, setStatoMenu] = useState({open: false, anchorEl: null})

    const username = spedizioniweb2?.user?.data?.user_login ?? null;
    const loginurl = spedizioniweb2.getLoginUrl({});
    const logouturl = spedizioniweb2.getLogoutUrl({});


    const elencoPagineAuth = ["_datifatturazione", "_preferenze", "_rubrica", "5"]
    const linksAuth = elencoPagineAuth.map(suffisso => spedizioniweb2.getLinkFromPaginaPreventivo({nome: `step${suffisso}`}))
        
    const currentStep = preventivoStorage?.step ?? null;
    let linkRiprendi = null;
    let linkCarrello = null;

    if(currentStep !== null){
        linkRiprendi = spedizioniweb2.getLinkFromPaginaPreventivo({nome: `step${currentStep}`});
    } 
        
    if((preventivi ?? []).length > 0){

        linkCarrello = spedizioniweb2.getLinkFromPaginaPreventivo({nome: `step4`});
    }
    


    logger.debug("menu utente", linkRiprendi);


    return(
        <>
            <Button onClick={e => setStatoMenu({open: true, anchorEl: e.currentTarget})}>
                <Person /> {username ?? `${__t("ospite")}`} 
            </Button>
            <VociMenuUtente {...{
                statoMenu, 
                setStatoMenu, 
                loginurl,
                logouturl,
                linksAuth,
                linkRiprendi,
                linkCarrello
            }} />

        </>
        
    )
}

const VociMenuUtente = ({
    statoMenu, 
    setStatoMenu, 
    loginurl,
    logouturl,
    linksAuth,
    linkRiprendi,
    linkCarrello
}) => {


    
    const MenuProps = {
        open: statoMenu.open,        
        onClose: e => {
            setStatoMenu({open: false, anchorEl: null})
        },
        // sx:{
        //     height: 250,
        // },
        anchorEl: statoMenu.anchorEl,         
    }

    return (
        <>
            <BSSMenu {...{MenuProps}} rightAlignment={false} >                

                <MenuItemAuth key="vocemenu_login" mostraA='guest' href={loginurl}>
                    {`${__t("accedi")} ${__t("o")} ${__t("registrati")}`}
                </MenuItemAuth>  

                <MenuItemAuth key="vocemenu_account" mostraA='auth' href={spedizioniweb2.accountManagementURL} target={"_blank"}>
                    {__t("gestioneaccount")}
                </MenuItemAuth>  
                
                {linksAuth.map(({permalink, link, label}, indice) => {

                    const chiave = `vocemenu_${indice}`
                    
                    return (
                        <MenuItemAuth key={chiave} mostraA='auth' href={permalink ?? link}>
                            {label}
                        </MenuItemAuth>  
                    )
                })}

                

                {linkRiprendi && (
                    <MenuItemAuth key="vocemenu_riprendipreventivo" href={linkRiprendi.permalink ?? linkRiprendi.link}>
                        {__t("continuapreventivo")}
                    </MenuItemAuth>  
                )}      

                {linkCarrello && (
                    <MenuItemAuth key="vocemenu_pagamenti" href={linkCarrello.permalink ?? linkCarrello.link}>
                        {__t("pagamenti")}
                    </MenuItemAuth>  
                )}        
                
                <MenuItemAuth key="vocemenu_logout" mostraA='auth' href={logouturl}>
                    {`${__t("esci")}`}
                </MenuItemAuth>
            </BSSMenu>
        </>
        
    )
}

const MenuItemAuth = ({mostraA = 'tutti', MenuItemProps = {}, href = null, target = null, children}) => {

    const userState = spedizioniweb2.isloggedin() ? 'auth' : 'guest';

    const mostra = mostraA === 'tutti' || mostraA === userState

    let isLink = href !== null;
    let isLinkToCurrentPage = false;
    if(isLink){
        isLinkToCurrentPage = href === location.href;
        isLink = isLink && !isLinkToCurrentPage;
    }

    const ItemComp = Link
    const ItemProps = !isLink ? {} : {href, target}

    return mostra ? (
        <MenuItem 
            component={ItemComp}
            disabled={isLinkToCurrentPage}
            sx={{"&:hover": {cursor: !isLinkToCurrentPage ? "pointer" : "default"}}} 
            {...MenuItemProps}             
            {...ItemProps}>
            {isLinkToCurrentPage && (
                <>
                    <ArrowRight />  
                    <Whitespace />
                </> 
            )}
            {children} 
        </MenuItem>   
    ) : "";
}

export default MenuUtente;